import React from 'react'

// example simple function component
const PageTitle = (props) => {
  return (
    <div>
      <h1>🚀 {props.coin} Daily Price Change Index🌛</h1>
    </div>
  )
}

export default PageTitle
